import property from 'lodash/property';

import { Pipe, PipeTransform } from '@angular/core';

import { getCycle } from '@app/new-cycle/cycles';

@Pipe({ name: 'cycleNew' })
export class NewCyclePipe implements PipeTransform {
  public transform(value, key = 'name') {
    const cycle = getCycle(value);
    const result = property(key)(cycle);
    return result != null ? result : '';
  }
}
